import api from 'services/api';
import { GET, userRoutes } from 'constants/api';

export const getPermissionByUser = userId =>
  api({
    method: GET,
    url: `${userRoutes.GET_PERMISSIONS_BY_USER}/${userId}`,
  });

export const getPermissionByRole = role =>
  api({
    method: GET,
    url: `${userRoutes.GET_PERMISSIONS_BY_ROLE}/${role}`,
  });

export const getAllPermissions = () =>
  api({
    method: GET,
    url: `${userRoutes.GET_ALL_PERMISSIONS}`,
  });

export const getCurrentProfile = () =>
  api({
    method: GET,
    url: userRoutes.GET_SIGNED_IN_USER_V2,
  });
